import React from 'react';
import { connect } from 'react-redux';
import {
  getTestResultTitle,
  hasReportDocuments,
  getTestPassedTitle,
  isComplete,
  isUnderReview,
  isResultNoTesting
} from 'helpers/RequestTestsHelper';
import { formatDate } from 'helpers/DateHelper';

const TestStatusTableRow = ({ tests }) => {
  if (!tests || !tests.length) return null;

  const testModule = tests[0];
  const {
    requestteststatusid,
    planversionAlias,
    actualstartdate,
    actualenddate,
    reportedat,
    reports,
    requesttestpassedstatusid
  } = testModule;

  const renderResult = () => {
    const mainTitle = getTestResultTitle(requestteststatusid);
    const tailTitle =
      isComplete(requestteststatusid) || isUnderReview(requestteststatusid)
        ? `— ${getTestPassedTitle(requesttestpassedstatusid)}`
        : '';
    return <b>{`${mainTitle} ${tailTitle}`}</b>;
  };

  const renderPassTestInfo = () => {
    if (hasReportDocuments(reports)) {
      return (
        <div>
          Test Plan Version: {planversionAlias}
          <br />
          Test Start Date: {formatDate(actualstartdate)}
          <br />
          Test Finish Date: {formatDate(actualenddate)}
          <br />
          Test Reported Date: {formatDate(reportedat)}
        </div>
      );
    }
  };

  const renderNoTestingInfo = () => {
    if (isResultNoTesting(requesttestpassedstatusid)) {
      return <div>Test Plan Version: {planversionAlias}</div>;
    }
  };

  return (
    <td className="col-xs-3 col-sm-3 col-md-3">
      <b>{renderResult()}</b>
      <br />
      {renderPassTestInfo()}
      {renderNoTestingInfo()}
    </td>
  );
};

function mapStateToProps({ tests }) {
  return { tests };
}

export default connect(mapStateToProps)(TestStatusTableRow);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/TestStatusTableRow.js